import * as React from 'react';
import { BgColorProvider } from '~theme/BgColorProvider';
import { useTheme } from '~theme/ThemeProvider';
import { Box } from '~ui/components/layout/Box';
import { useCompanyStylesCtx } from '../../../contexts/CompanyStylesContext/CompanyStylesProvider';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * A card with a background image of the company.
 */
export var CompanyImageCard = function CompanyImageCard(_ref) {
  var padding = _ref.padding,
      height = _ref.height,
      minHeight = _ref.minHeight,
      children = _ref.children;
  var theme = useTheme();
  var companyStyles = useCompanyStylesCtx();
  var imageUrl = companyStyles.images.heroImageUrl;
  var bgImage = "linear-gradient(".concat(theme.specialColors.overlayLite, ",").concat(theme.specialColors.overlayMedium, "), url(\"").concat(imageUrl, "\")");
  return /*#__PURE__*/_jsx(Box, {
    padding: padding,
    height: height,
    minHeight: minHeight,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: bgImage,
    children: /*#__PURE__*/_jsx(BgColorProvider, {
      bgColor: "specialColors.overlayMedium",
      children: children
    })
  });
};